import Box from '@mui/material/Box'
import { Select } from '../../1elements'

const TemplateNameDropdown = ({
  value,
  onChange,
  disabled,
  templateOptions
}) => {
  return (
    <Box sx={{ maxWidth: 400, minWidth: 150, position: 'relative' }}>
      <Select
        options={templateOptions}
        optionLabelKey={'template_name'}
        value={
          value &&
          templateOptions.find(
            option =>
              option.template_name.toLowerCase() ===
              value.template_name.toLowerCase()
          )
        }
        onChange={onChange}
        helperText={'Select One'}
        disabled={disabled}
      />
    </Box>
  )
}

export default TemplateNameDropdown
